module.exports = __webpack_public_path__ + "img/logo_ornithologiki.961162a6.jpg";